import AuthService from "../login/auth.service";
import { transferencias } from "../../components/generico/utils/UrlAPI";
import {dimo } from "../../components/generico/utils/UrlAPI";
import axios from "axios";


class AliasService {

    async getListadoAlias() {

        var config = {
            method: "get",
            url: dimo + "alias",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + AuthService.getCurrentToken()
            },
        };

        return await axios(config);
    }


    async getTipoAlias() {

        var config = {
            method: "get",
            url: dimo + "alias/tipo-alias",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + AuthService.getCurrentToken()
            },
        };

        return await axios(config);
    }


    async getEliminarAlias(alias, tipoAlias) {
      let payload = {    
        tipoAlias: tipoAlias,
        alias: alias,
        
      };
      var config = {
          method: "delete",
          url: dimo + "alias/eliminar",
          params: payload,
          headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + AuthService.getCurrentToken()
          },
      };

      return await axios(config);
  }


    async registarAlias(
        alias,
        cuentaDebito,
        TipoCuentaDebito,
        tipoAlias,
      ) {
    
        var data = JSON.stringify({
          alias: alias,
          tipoAlias: tipoAlias,
          numeroCuenta: cuentaDebito,
          tipoCuenta: TipoCuentaDebito,
         
        });
    
        var config = {
          method: "post",
          url: dimo + "alias/registrar",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + AuthService.getCurrentToken()
          },
          data: data,
        };
        return await axios(config);
      }


    // async consultaCantidadTransferencias(){
    //     let config = {
    //         method : 'get',
    //         url: transferencias + "transferencia/exceso/cobro-transf-interb",
    //         headers : {
    //             "Content-Type": "application/json",
    //             Authorization: "Bearer " + AuthService.getCurrentToken()
    //         }
    //     }
    //     return await axios(config);
    // }

}
export default new AliasService();
